<template>
    <div class="content-grid-resources-collection-thumbnail" />
    <div class="content-grid-resources-collection-thumbnail__overlay">
        <div class="content-grid-resources-collection-thumbnail__info">
            <div class="content-grid-resources-collection-thumbnail__title">{{ $t('resources.collection') }}</div>
        </div>
    </div>
</template>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .content-grid-resources-collection-thumbnail {
        border: 1px solid var(--joy-color-primary-50);
        padding: var(--joy-core-spacing-6);
        border-radius: var(--joy-core-radius-3);
        background-image: url('../../../../assets/svg/collection-background.svg');
        position: relative;
        overflow: hidden;
        width: 100%;
        background-repeat: no-repeat;
        background-size: cover;
        max-height: 141px;
        height: 100%;

        @include mq.screen_sm(min) {
            max-height: 100%;
        }

        &__overlay {
            max-width: 140px;
            max-height: 48px;
            position: absolute;
            top: -4px;
            left: -3px;
            background-color: var(--joy-color-neutral-70);
            z-index: 1;
            width: 220px;
            height: 72px;
            border-radius: 0 0 100px;
            transform: rotate(-4deg);
        }

        &__info {
            position: absolute;
            left: 20px;
            top: 15px;
            z-index: 3;
            color: var(--joy-color-neutral-0);
            transform: rotate(4deg);
        }

        &__title {
            font-weight: var(--joy-font-weight-bold);
            font-family: var(--joy-font-family-title);
            line-height: 1;
        }
    }
</style>
